
import "./../styles/companyProfile.css";
import React from "react";
const CompanyProfile = () => {
  return (
    <>
      <div className="BriefIntroduction">
        <img src="/assets/briefIntroduction.png" alt="公司简介" />
        <div className="content">
          <p>
            江苏云网数智信息技术有限公司成立于2022年，坐落于江苏省南京市，是一家专注于高新技术研发与应用的创新型企业，在行业内展现出了强大的综合实力和蓬勃的发展活力。
          </p>
          <p>
            公司致力于让网络安全更智能，让城市生活更数智：我们秉持“精准导航、智慧出行”理念，专注于地图数据采集处理及应用；我们深耕政务、能源、通信、交通等领域，凭借技术实力和专业团队拓展服务、提升质量；我们坚持创新驱动，深入探索并拓展数字孪生技术应用场景；我们紧跟时代步伐，引进先进安全技术，强化自主创新能力，研发高效安全产品与服务。
          </p>
          <p>
            展望未来，江苏云网数智信息技术有限公司将继续秉承“创新、卓越、服务”的理念，不断提升技术水平和服务质量，为客户提供更加优质、高效的技术解决方案。
          </p>
        </div>
      </div>
      <div className="honor">
        <div className="honorTitle">公司荣誉</div>
        <div className="honorSubTitle">
          合作共赢,为合作伙伴提供更优质的解决方案
        </div>
        <div className="honorContent">
          <img src="/assets/horner.png" alt="荣誉资质" />
        </div>
      </div>
    </>
  );
};
export default CompanyProfile;
